export function getQueryParamFromUrl() {
  const objUrl = new URL(window.location.href);
  const searchParam: Record<string, string | string[]> = {};
  objUrl.searchParams.forEach(function (value, key) {
    searchParam[key] = value;
  });
  return searchParam;
}

export const changeLinkFromApp = function (): string | null {
  if (window.location.href.includes("from_app")) return `banimode://?`;
  else return null;
};
export const updateUrlParams = function (newParams: any) {
  const params = new URLSearchParams(window.location.search);
  for (const key in newParams) {
    params.set(key, newParams[key]);
  }
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.pushState({}, "", newUrl);
};
